import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'
import { Asterisk } from '@/components/generals/asterisk'

interface SectionLabelProps {
    children: ReactNode
    className?: string
    markClassName?: string
}

export const SectionLabel: FC<SectionLabelProps> = ({ children, className, markClassName = 'text-brand' }): ReactNode => {
    return (
        <p className={cn('inline-flex items-center gap-2 font-mono text-[11px] font-medium uppercase tracking-[0.16em]', className)}>
            <Asterisk className={cn('size-3 shrink-0', markClassName)} />
            {children}
        </p>
    )
}
